import { useQuery, useQueryClient } from "@tanstack/react-query"
import { PortPredictorVesselSpeed, usePortPredictorAPI } from "./usePortPredictorAPI"
import { VesselSegment } from "user/userService";

export function useFetchVesselJourneySpeed(imo: number | undefined, segment: VesselSegment, savedChosenVesselSpeedData: PortPredictorVesselSpeed[] | undefined) {
  const { getChosenVesselSpeed } = usePortPredictorAPI()
  const queryClient = useQueryClient()

  const shouldNotFetch = !!savedChosenVesselSpeedData;
  queryClient.invalidateQueries({ queryKey: ["portPredictor/getChosenVesselSpeed", imo, segment, shouldNotFetch] })

  const {
    isLoading: isChosenVesselSpeedLoading,
    isError: isChosenVesselSpeedError,
    isSuccess: isChosenVesselSpeedSuccess,
    data: chosenVesselSpeedData,
  } = useQuery({
    queryKey: ["portPredictor/getChosenVesselSpeed", imo, segment, shouldNotFetch],
    queryFn: () => {
      if (shouldNotFetch) { return savedChosenVesselSpeedData }
      const result = getChosenVesselSpeed(imo, segment)
      return result
    },
    onSuccess: (resolvedData) => {
      // console.log("Resolved speed array:", resolvedData)
    },
    staleTime: shouldNotFetch ? 600000 : 0, // 10 minutes
  })

  return {
    isChosenVesselSpeedLoading,
    isChosenVesselSpeedError,
    isChosenVesselSpeedSuccess,
    chosenVesselSpeedData,
  }
}
